import htmlLogo from "../../images/htmllogo.svg";
import cssLogo from "../../images/css3.svg";
import javascriptLogo from "../../images/javascriptlogo.svg";
import nodeLogo from "../../images/nodejs.svg";
import reactLogo from "../../images/reactlogo1.svg";
import mongoLogo from "../../images/mongodb.svg";
import typescriptLogo from "../../images/Typescript.svg";
import firebaseLogo from "../../images/firebase.svg";
import handlebarsLogo from "../../images/handlebars.svg";

export const logos = [
  { title: "html", image: htmlLogo },
  { title: "css", image: cssLogo },
  { title: "javaScript", image: javascriptLogo },
  { title: "nodeJS", image: nodeLogo },
  { title: "react", image: reactLogo },
  { title: "mongoDB", image: mongoLogo },
  { title: "handlebars", image: handlebarsLogo },
  { title: "typescript", image: typescriptLogo },
  { title: "firebase", image: firebaseLogo },
];
